import { render, staticRenderFns } from "./UserInQuarantineError.vue?vue&type=template&id=4844fe10"
import script from "./UserInQuarantineError.vue?vue&type=script&lang=js"
export * from "./UserInQuarantineError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports